import React from 'react';
import "./Ballot.css";

import { useParams } from "react-router-dom";
import { useApi } from "../../hooks/useApi";
import { UserAuth } from '../../context/AuthContext';
import VotingCard from '../../components/Voting/VotingCard/VotingCard';
import Results from '../Results/Results';
import BackButton from '../../components/Buttons/BackButton/BackButton';
import LoadingCircle from '../../components/Global/LoadingCircle';

export default function Ballot() {
    const { user } = UserAuth();
    const { ballotId } = useParams();
    const { api } = useApi();

    const [ballot, setBallot] = React.useState(null);

    React.useEffect(() => {
        const fetchData = async () => {
            const result = await api(`ballot/${ballotId}`, "GET");
            setBallot(result);
        }

        fetchData();
    }, [ballotId, user]);


    return (
        <>
        { ballot?
        <div className="voteStatusButtonContainer">
            <div className='votingContainer'>
                {
                    <div>
                        {ballot && ballot.closedAt === null && ballot.title && <VotingCard ballot={ballot} ballotId={ballotId} />}

                        {ballot && ballot.question && ballot.closedAt !== null && <Results ballot={ballot} />}
                    </div>
                }
            </div>
        </div> : <LoadingCircle />
        }
        </>
    );

}
